<script setup lang="ts">
//#region import
import { computed } from 'vue';
import { useStore } from 'vuex';
//#endregion

//#region types
interface Props {
  currentBrand: string;
}

interface  Emits {
  'brand-change': [value: string],
}
//#endregion

//#region define
const props = defineProps<Props>();
const emit = defineEmits<Emits>();
//#endregion

//#region const
const store = useStore();
//#endregion

//#region computed
const brands = computed(() => store.getters['misc/brands']);
//#endregion

const handleSelectBrand = (id: string) => {
  emit('brand-change', id);
};

</script>

<template>
  <div class="brands-list t:space-x-16">
    <div
      v-for="item in brands"
      :key="item.id"
      :class="[
        'brands-list__item',
        {'brands-list__item_active': item.id === props.currentBrand}
      ]"
      @click="handleSelectBrand(item.id)"
    >
      <img
        v-if="item.favicon_base64"
        class="brands-list__item-img"
        :src="item.favicon_base64"
        :alt="item.name"
      >
      {{ item.name }}
    </div>
  </div>
</template>

<style lang="scss">
.brands-list {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 16px;
  border-bottom: 1px solid var(--border-divider);
  &__item {
    display: flex;
    align-items: flex-start;
    cursor: pointer;
    color: var(--text-body);
    font-size: 16px;
    height: 36px;
    position: relative;

    &_active {
      font-weight: 500;
      &:after {
        content: '';
        left: 0;
        right: 0;
        height: 2px;
        background-color: var(--border-focused);
        position: absolute;
        bottom: 0;
      }
    }
  }
  &__item-img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    border-radius: 4px;
  }
}
</style>
